/*============================================================================
HDG Scripts
==============================================================================*/

(function () {

  /*============================================================================
    Enable infinite scroll on search results page
  ==============================================================================*/

  if (location.pathname.startsWith("/search")) {

    // Toggle debug logs
    const HDG_DEBUG = true;
    const log = (...args) => { if (HDG_DEBUG) console.log("[HDG Search Infinite]", ...args); };
    const warn = (...args) => { if (HDG_DEBUG) console.warn("[HDG Search Infinite]", ...args); };

    const GRID_SEL = '[data-load-more--grid]';
    const ITEM_SEL = '[data-load-more--grid-item]';

    // More robust next-link selectors for Flex variants
    const NEXT_SELECTORS = [
      'nav.pagination a.pagination-next',
      'a.pagination-next',
      'link[rel="next"]',
      'nav.pagination a[rel="next"]',
      '.pagination a[rel="next"]',
      '.pagination__next a',
    ];

    // Super snappy settings
    const PREFETCH_PX = 7000; // start fetching earlier
    const APPEND_PX   = 1600; // append sooner
    const FALLBACK_SKELETONS = 12;

    const PRELOAD_LIMIT = 48; // preload up to N images from the next page

    const grid = document.querySelector(GRID_SEL);
    if (grid) {

      log("Init: grid found", grid);

      // Hide pagination for "true infinite"
      const hidePagStyle = document.createElement("style");
      hidePagStyle.textContent = `nav.pagination{display:none !important;}`;
      document.head.appendChild(hidePagStyle);

      // Skeleton shimmer styles (lightweight)
      const skelStyle = document.createElement("style");
      skelStyle.textContent = `
        .hdg-skel-item {
          border-radius: 8px;
          overflow: hidden;
          background: rgba(0,0,0,.04);
          position: relative;
          min-height: 420px;
        }
        .hdg-skel-item:before{
          content:"";
          position:absolute; inset:0;
          background: linear-gradient(90deg, rgba(0,0,0,.04), rgba(0,0,0,.10), rgba(0,0,0,.04));
          background-size: 200% 100%;
          animation: hdgShimmer 1.2s infinite;
        }
        @keyframes hdgShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
      `;
      document.head.appendChild(skelStyle);

      function getNextUrl(rootDoc) {
        for (const sel of NEXT_SELECTORS) {
          const el = rootDoc.querySelector(sel);
          if (!el) continue;

          // <link rel="next" href="...">
          if (el.tagName === "LINK" && el.getAttribute("href")) return el.href;

          // <a href="...">
          if (el.tagName === "A" && el.href) return el.href;
        }
        return null;
      }

      function distanceFromBottom() {
        const scrollY = window.scrollY || window.pageYOffset;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const full = document.documentElement.scrollHeight;
        return full - (scrollY + vh);
      }

      // Skeleton count: match current page count if possible
      function getPageSizeGuess() {
        const items = grid.querySelectorAll(ITEM_SEL);
        return items && items.length ? items.length : FALLBACK_SKELETONS;
      }

      // Create skeleton nodes using the *same classes* as real grid items
      function createSkeletonNodes(count) {
        const template = grid.querySelector(ITEM_SEL);
        const className = template ? template.className : "";

        const nodes = [];
        for (let i = 0; i < count; i++) {
          const d = document.createElement("div");
          d.setAttribute("data-hdg-skeleton", "1");

          // Keep Flex attribute targeting consistent
          d.setAttribute("data-load-more--grid-item", "");

          d.className = className || "column one-fourth medium-down--one-half small-down--one-half";
          d.innerHTML = `<div class="hdg-skel-item"></div>`;
          nodes.push(d);
        }
        return nodes;
      }

      function clearSkeletons() {
        const skels = grid.querySelectorAll('[data-hdg-skeleton="1"]');
        if (skels.length && HDG_DEBUG) log("Clear skeletons:", skels.length);
        skels.forEach((n) => n.remove());
      }

      function showSkeletons() {
        if (grid.querySelector('[data-hdg-skeleton="1"]')) return;
        const count = getPageSizeGuess();
        if (HDG_DEBUG) log("Show skeletons:", count);
        createSkeletonNodes(count).forEach((n) => grid.appendChild(n));
      }

      function parseNextPage(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = doc.querySelector(GRID_SEL);
        if (!nextGrid) return { items: [], next: null };

        // Prefer Flex cards
        const items = Array.from(nextGrid.querySelectorAll(ITEM_SEL));
        // Fallback if structure changes:
        const nodes = items.length
          ? items
          : Array.from(nextGrid.children).filter((n) => n.nodeType === 1);

        const next = getNextUrl(doc);
        return { items: nodes, next };
      }

      // --- Image preloading (super snappy) ---
      const imagePreloadCache = new Set();

      function normalizeUrl(url) {
        if (!url) return null;
        if (url.startsWith("//")) return location.protocol + url;
        return url;
      }

      function pickFromSrcset(srcset) {
        // Pick last candidate (often largest). Good for “snappy” feel.
        try {
          const parts = srcset
            .split(",")
            .map((s) => s.trim().split(" ")[0])
            .filter(Boolean);
          return parts.length ? parts[parts.length - 1] : null;
        } catch (e) {
          return null;
        }
      }

      function preloadImagesFromNodes(nodes, limit = PRELOAD_LIMIT) {
        let count = 0;

        nodes.forEach((node) => {
          if (count >= limit) return;

          const imgs = node.querySelectorAll("img");
          imgs.forEach((img) => {
            if (count >= limit) return;

            const src =
              img.getAttribute("data-src") ||
              img.getAttribute("src") ||
              null;

            const srcset =
              img.getAttribute("data-srcset") ||
              img.getAttribute("srcset") ||
              null;

            let url = src || (srcset ? pickFromSrcset(srcset) : null);
            url = normalizeUrl(url);

            if (!url) return;
            if (imagePreloadCache.has(url)) return;
            imagePreloadCache.add(url);

            const i = new Image();
            i.decoding = "async";
            i.src = url;

            count++;
          });
        });

        if (HDG_DEBUG) log("Preloaded image requests:", count);
      }

      // --- Lazyload bumpers ---
      function bumpLazyloadWithin(root) {
        // Lazysizes (common in Flex)
        if (window.lazySizes && window.lazySizes.loader) {
          try {
            const imgs = root.querySelectorAll(
              "img.lazyload, img.lazyautosizes, img[data-src], img[data-srcset]"
            );
            let unveiled = 0;
            imgs.forEach((img) => {
              if (img.classList.contains("lazyloaded")) return;
              window.lazySizes.loader.unveil(img);
              unveiled++;
            });
            if (HDG_DEBUG && unveiled) log("Unveiled images in appended block:", unveiled);
          } catch (e) {
            warn("bumpLazyloadWithin error:", e);
          }
        } else if (HDG_DEBUG) {
          warn("lazySizes not found on window (this is OK if theme uses a different lazy loader).");
        }
      }

      function bumpLazyloadGlobal() {
        window.dispatchEvent(new Event("resize"));
        window.dispatchEvent(new Event("scroll"));
      }

      // --- State ---
      let nextUrl = getNextUrl(document);
      let done = !nextUrl;

      let prefetched = null; // { items: Node[], next: string|null }
      let prefetching = false;
      let appending = false;

      log("Initial nextUrl:", nextUrl);

      async function prefetch() {
        if (done || prefetching || prefetched || !nextUrl) return;

        prefetching = true;
        grid.setAttribute("data-hdg-prefetching", "true");
        log("Prefetch start:", nextUrl);

        try {
          const res = await fetch(nextUrl, { credentials: "same-origin" });
          if (!res.ok) throw new Error("Prefetch failed: " + res.status);
          const html = await res.text();

          const { items, next } = parseNextPage(html);
          prefetched = { items, next };

          log("Prefetch parsed items:", items.length, "next:", next);

          // Start image downloads NOW
          if (items && items.length) preloadImagesFromNodes(items, PRELOAD_LIMIT);
        } catch (e) {
          console.error("[HDG Search Infinite] Prefetch error:", e);
          prefetched = null;
        } finally {
          prefetching = false;
          grid.removeAttribute("data-hdg-prefetching");
        }
      }

      async function appendNext() {
        if (done || appending) return;
        appending = true;
        grid.setAttribute("data-hdg-appending", "true");

        showSkeletons();

        try {
          // Use prefetched if available
          if (prefetched && prefetched.items && prefetched.items.length) {
            log("Append from prefetched:", prefetched.items.length);

            clearSkeletons();

            const frag = document.createDocumentFragment();
            const appended = [];

            prefetched.items.forEach((node) => {
              const el = document.importNode(node, true);
              appended.push(el);
              frag.appendChild(el);
            });

            grid.appendChild(frag);

            appended.forEach((el) => bumpLazyloadWithin(el));
            bumpLazyloadGlobal();

            nextUrl = prefetched.next;
            prefetched = null;

            log("Append done. nextUrl:", nextUrl);

            if (!nextUrl) done = true;
            return;
          }

          // Fallback fetch if prefetch didn't happen
          if (!nextUrl) {
            done = true;
            clearSkeletons();
            log("No nextUrl. Done.");
            return;
          }

          log("Fallback fetch append:", nextUrl);

          const res = await fetch(nextUrl, { credentials: "same-origin" });
          if (!res.ok) throw new Error("Fetch failed: " + res.status);
          const html = await res.text();

          const { items, next } = parseNextPage(html);
          clearSkeletons();

          if (!items.length) {
            done = true;
            log("No items returned. Done.");
            return;
          }

          preloadImagesFromNodes(items, PRELOAD_LIMIT);

          const frag = document.createDocumentFragment();
          const appended = [];

          items.forEach((node) => {
            const el = document.importNode(node, true);
            appended.push(el);
            frag.appendChild(el);
          });

          grid.appendChild(frag);

          appended.forEach((el) => bumpLazyloadWithin(el));
          bumpLazyloadGlobal();

          nextUrl = next;
          log("Append done (fallback). nextUrl:", nextUrl);

          if (!nextUrl) done = true;
        } catch (e) {
          console.error("[HDG Search Infinite] Append error:", e);
          clearSkeletons();
          done = true;
        } finally {
          appending = false;
          grid.removeAttribute("data-hdg-appending");
        }
      }

      // Scroll loop (throttled)
      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;

          const dist = distanceFromBottom();

          if (dist < PREFETCH_PX) prefetch();
          if (dist < APPEND_PX) appendNext();
        });
      }

      window.addEventListener("scroll", onScroll, { passive: true });

      // Kick once for short pages
      setTimeout(onScroll, 600);

    } else {
      console.warn("[HDG Search Infinite] Grid not found, exiting search infinite logic.");
    }
  }


  /*============================================================================
  Homepage sliders: wrap Flickity prev/next buttons in a div
  ==============================================================================*/
  function wrapControls() {
    if (!document.body.classList.contains('index')) return;

    var prevButtons = document.querySelectorAll('.flickity-prev-next-button.previous');

    prevButtons.forEach(function (prev) {

      if (prev.closest('.custom-slider-controls')) return;

      var parent = prev.parentNode;
      var next = parent && parent.querySelector('.flickity-prev-next-button.next');
      if (!parent || !next) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'custom-slider-controls';

      var label = document.createElement('span');
      label.textContent = 'Product Slider Controls';

      parent.insertBefore(wrapper, prev);

      wrapper.appendChild(prev);
      wrapper.appendChild(label);
      wrapper.appendChild(next);

    });
  }

  window.addEventListener('load', function () {
    setTimeout(wrapControls, 100);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(wrapControls, 100);
  });

  // Move new controls wrapper above flickity slider
  function moveControls() {
    if (!document.body.classList.contains('index')) return;

    var wrappers = document.querySelectorAll('.slider-gallery .custom-slider-controls');

    wrappers.forEach(function (wrapper) {

      var slider = wrapper.closest('.slider-gallery');
      if (!slider) return;

      var container = slider.closest('.featured-collection');
      if (!container) return;

      container.insertBefore(wrapper, slider);
    });
  }

  window.addEventListener('load', function () {
    setTimeout(moveControls, 100);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(moveControls, 100);
  });


  /*============================================================================
  Collection sidebar: accordion menu
  ==============================================================================*/
  function initSidebarAccordion() {
    document.querySelectorAll('.sidebar-toggle').forEach(function (btn) {

      // Avoid double-binding if this function runs more than once
      if (btn.dataset.hdgBound === "1") return;
      btn.dataset.hdgBound = "1";

      btn.addEventListener('click', function () {

        const item = this.closest('.sidebar-item');
        if (!item) return;

        const submenu = item.querySelector('.sidebar-submenu');
        const isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open');

        if (submenu) {
          submenu.classList.toggle('is-open');
        }

        // aria-expanded expects "true"/"false"
        this.setAttribute('aria-expanded', String(!isOpen));

      });

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebarAccordion);
  } else {
    initSidebarAccordion();
  }

  document.addEventListener('shopify:section:load', function () {
    initSidebarAccordion();
  });

  /*============================================================================
  Cart: Back to Search Results Button + Continue Shopping + Restore Search Results Scroll Position
  ==============================================================================*/

  document.addEventListener("DOMContentLoaded", function () {
    const isSearchPage = window.location.pathname.startsWith("/search");
    const isCartPage = window.location.pathname.startsWith("/cart");

    /*--------------------------------------
      Save current search URL
    --------------------------------------*/
    if (isSearchPage) {
      sessionStorage.setItem(
        "hdg_last_search_results_url",
        window.location.pathname + window.location.search
      );
    }

    /*--------------------------------------
      Save scroll position on search page
    --------------------------------------*/
    if (isSearchPage) {
      let scrollTimer;

      window.addEventListener("scroll", function () {
        if (sessionStorage.getItem("hdg_search_restore_active") === "true") return;

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(function () {
          sessionStorage.setItem(
            "hdg_last_search_results_scroll_y",
            String(window.scrollY || window.pageYOffset || 0)
          );
        }, 100);
      });
    }

    /*--------------------------------------
      Cart page button behavior
    --------------------------------------*/
    if (isCartPage) {
      const savedSearchUrl = sessionStorage.getItem("hdg_last_search_results_url");
      const hasSavedSearchUrl =
        savedSearchUrl && savedSearchUrl.startsWith("/search");

      // Back to Search Results button
      const wrapper = document.getElementById("cart-back-to-search");
      const backLink = document.getElementById("cart-back-to-search-link");

      if (hasSavedSearchUrl && wrapper && backLink) {
        backLink.href = savedSearchUrl;
        wrapper.style.display = "";
      }

      // Continue Shopping button(s)
      if (hasSavedSearchUrl) {
        document
          .querySelectorAll(".js-continue-shopping-link")
          .forEach(function (link) {
            link.href = savedSearchUrl;
          });
      }
    }

    /*--------------------------------------
      Restore scroll position on search page
    --------------------------------------*/
    if (isSearchPage) {
      const savedSearchUrl = sessionStorage.getItem("hdg_last_search_results_url");
      const savedScrollY = sessionStorage.getItem("hdg_last_search_results_scroll_y");
      const currentUrl = window.location.pathname + window.location.search;

      if (!savedSearchUrl || !savedScrollY) return;
      if (savedSearchUrl !== currentUrl) return;

      const targetY = parseInt(savedScrollY, 10);
      if (isNaN(targetY) || targetY < 0) return;

      const grid = document.querySelector('[data-load-more--grid]');
      if (!grid) return;

      let attempts = 0;
      const maxAttempts = 120;

      function isBusy() {
        return (
          grid.hasAttribute("data-hdg-appending") ||
          grid.hasAttribute("data-hdg-prefetching")
        );
      }

      function getDocHeight() {
        return Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );
      }

      function getViewportHeight() {
        return window.innerHeight || document.documentElement.clientHeight || 0;
      }

      function triggerNextLoadZone() {
        const docHeight = getDocHeight();
        const viewportHeight = getViewportHeight();

        // Move near the bottom so the infinite scroll logic hits APPEND_PX
        const nearBottomY = Math.max(0, docHeight - viewportHeight - 1200);
        window.scrollTo(0, nearBottomY);
        window.dispatchEvent(new Event("scroll"));
      }

      function finishRestore() {
        sessionStorage.removeItem("hdg_search_restore_active");
        window.scrollTo(0, targetY);
      }

      function restoreSearchPosition() {
        attempts += 1;

        const docHeight = getDocHeight();
        const viewportHeight = getViewportHeight();

        // Once page is tall enough, do final exact restore
        if (docHeight >= targetY + viewportHeight || attempts >= maxAttempts) {
          finishRestore();
          return;
        }

        // If currently loading/appending, wait and check again
        if (isBusy()) {
          setTimeout(restoreSearchPosition, 350);
          return;
        }

        // Trigger another infinite-scroll load cycle
        triggerNextLoadZone();

        // Wait for append to begin and finish
        setTimeout(restoreSearchPosition, 500);
      }

      sessionStorage.setItem("hdg_search_restore_active", "true");

      // Start from the top so restore behavior is predictable
      window.scrollTo(0, 0);

      // Give the initial search page a moment to initialize infinite scroll
      setTimeout(restoreSearchPosition, 700);
    }
  });

})();